<div class="page-content">
    <div class="content-header">
        <span class="title">Purchase Gift Card</span>
        <div class="actions" *ngIf="isCheckBalanceFeatureEnabled()">
            <span>Already have a gift card?</span>
            <button
                mat-stroked-button
                color="primary"
                class="balance-btn ols-mat-stroked-button-color"
                (click)="goToGiftCardBalancePage()"
                qa="check-balance-button"
            >
                Check Balance
            </button>
        </div>
    </div>
    <div class="content-body">
        <form [formGroup]="form">
            <ols-design-and-amount
                class="content-box"
                [designs]="designs"
                [customAmountSettings]="customAmountSettings"
                [suggestedAmounts]="suggestedAmounts"
            ></ols-design-and-amount>
            <ols-gift-card-sender-information class="content-box">
            </ols-gift-card-sender-information>
            <ols-gift-card-recipient-option
                class="content-box"
                [selectedTabIndex]="selectedRecipientTabIndex"
            >
            </ols-gift-card-recipient-option>
            <ols-gift-card-message class="content-box"></ols-gift-card-message>
        </form>
    </div>
    <div class="content-footer">
        <button
            mat-flat-button
            (click)="submitForm()"
            color="primary"
            qa="checkout-giftcard"
        >
            Checkout
        </button>
    </div>
</div>
